module.exports = __webpack_public_path__ + "static/media/client16.640c5863.webp";